import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import logo from '../../assets/images/vectorpaint.svg';
import logo2 from '../../assets/images/portal.png';
import Select from 'react-select';
import { makeStyles } from '@material-ui/styles';
import Select2 from "react-select2-wrapper";
import {
    Form
} from "reactstrap";
import {
    AppBar,
    Button,
    IconButton,
    Toolbar,
    Hidden,
    Paper, Link, Typography, TextField
} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import MenuIcon from '@material-ui/icons/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { getComapanyNames, getVendorData, logout } from '../../actions';
import Navbar from "react-bootstrap/Navbar";
import axios from 'axios';
import {requests, VERSION_APP,SYSTEM, LOGOUT } from 'src/constants/config';
const useStyles = makeStyles(theme => ({
    root: {
        boxShadow: 'none',
        backgroundColor: '#2f3e46'
    },
    input: {
        padding: '11.5px 14px'
    },
    flexGrow: {
        flexGrow: 1
    },
    details: {
        color: '#FFF',
        marginLeft: '10px'
    },
    left: {
        textAlign: 'center'
    },
    search: {
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'right'
    },
    searchIcon: {
        marginRight: theme.spacing(2),
        color: 'inherit'
    },
    searchInput: {
        flexGrow: 1,
        color: 'inherit',
        '& input::placeholder': {
            opacity: 1,
            color: 'inherit'
        }
    },
    searchPopper: {
        zIndex: theme.zIndex.appBar + 100
    },
    searchPopperContent: {
        marginTop: theme.spacing(1)
    },
    menuButton: {
        marginRight: theme.spacing(1)
    },
    logoutButton: {
        marginLeft: theme.spacing(1)
    },
    logoutIcon: {
        marginRight: theme.spacing(1)
    }
}));

function TopBar({ onOpenNavBarMobile, className, ...rest }) {

    const dispatch = useDispatch();
    const classes = useStyles();
    const session = useSelector((state) => state.session);
    const companyNames = useSelector((state) => state.companyNames.data);
    const selectedVendorId = useSelector((state) => state.session.selectedVendorId);
    const [vendorData, setVendorData] = useState({});
    const options = {
        placeholder: "Select"
    };
    const customStyles = {
        option: (provided, state) => ({
            fontfamily:"Roboto",
            fontSize: "14px",
            cursor: "pointer",
            width: "100%"
        })
    };
    

    const handleChange = (event) => {
        dispatch(getVendorData(event.target.value));
    };

    const handleLogout = () => {                 
        const LogoutProveedor = async () => {
            const config = {
                method: 'post',
                url: requests.logInOut,
                data: {
                    'p_logins_id': session.user.userId,
                    'operacion':LOGOUT,
                    'sistema':SYSTEM,
                    'version': VERSION_APP
                }
            };
            await axios(config)
                .then(function(response) {                    
                    console.log(response);
                })
                .catch(function(error) {
                    console.log(error);
                });
        };
        LogoutProveedor();

        dispatch(logout());
    };

    useEffect(() => {
        if (companyNames.length < 0) {            
           // dispatch(getComapanyNames(vendorData.custentity_be_rfc_sat));
           dispatch(getComapanyNames(session.user.correo));
        }
    }, [selectedVendorId]);

    return (

        <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
            <Toolbar>
                <Hidden lgUp>
                    <IconButton
                        className={classes.menuButton}
                        color="inherit"
                        onClick={onOpenNavBarMobile}
                    >
                        <MenuIcon/>
                    </IconButton>
                </Hidden>
                <RouterLink to="/">
                    <img alt="Logo" src={logo} height="40px"/>
                    <img alt="Logo2" src={logo2} height="40px"/>
                </RouterLink>
                <div className={classes.flexGrow}/>

                <Hidden smDown>
                    <div className={classes.search}>
                        <Paper>
                            <TextField
                                select
                                required
                                InputProps={{
                                    classes: {
                                        input: classes.input
                                    }
                                }}
                                name="vendorId"
                                value={selectedVendorId}
                                fullWidth
                                variant="outlined"
                                onChange={handleChange}
                                SelectProps={
                                    { native: true }
                                }
                            >
                                <option value={0} disabled>Seleccionar razón social</option>
                                {
                                    companyNames != null && companyNames.map(razon => {
                                        return <option
                                            defaultValue={selectedVendorId === razon.numpro}
                                            value={razon.numpro}
                                            key={razon.numpro}>
                                            {razon.razonSocial+" "+razon.numpro}
                                        </option>;
                                    })
                                }
                            </TextField>

                        </Paper>
                    </div>
                </Hidden>

                <Hidden mdDown>
                    <div className={classes.profile}>
                        <div className={classes.details}>
                            <Link
                                className={classes.details}
                                component={RouterLink}
                                to="/profile/1/timeline"
                                variant="h5"
                                color="textPrimary"
                                underline="none">
                                {session.user.nombre + ' ' } {session.user.apellido ? session.user.apellido : ''}
                            </Link>
                            <Typography
                                className={classes.details}
                                variant="body2">
                                {/*session.user.proveDesc*/}
                            </Typography>
                        </div>
                    </div>
                    <Button
                        className={classes.logoutButton}
                        color="inherit"
                        onClick={handleLogout}>
                        <InputIcon className={classes.logoutIcon}/>
                        Salir
                    </Button>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
}

TopBar.propTypes = {
    className: PropTypes.string,
    onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
